import type { PlatformChannel } from '../../utils/map-connection-to-row';
import type { SolutionResolver } from '../../utils/resolve-solution-by-bot-id';

/**
 * Where a "Channels Using It" pill leads, or `null` when it leads nowhere.
 *
 * The channel route is `/:projectId/:botId/channels/:channelId`, where `:botId`
 * is the solution id, resolved from the channel's start-chat bot id by the SAME
 * resolver the solution boxes group by. A Contact Center (vaapi) channel has no
 * settings page in Pro Studio, so it opens the Channels list.
 */
export const buildChannelRoute = (
  channel: PlatformChannel,
  projectId: string | null | undefined,
  resolveSolution: SolutionResolver<{
    id?: string;
    botSolutionId?: string | null;
  }>
): string | null => {
  const solutionId = resolveSolution(channel.botId)?.id;
  if (!projectId || !solutionId || !channel.channelId) return null;

  const base = `/${projectId}/${solutionId}`;
  if (channel.type === 'vaapi') return `${base}/channels`;
  if (channel.type === 'twilio_voice') {
    return `${base}/voice-channel/${channel.channelId}`;
  }
  return `${base}/channels/${channel.channelId}`;
};

/**
 * A solution's Versions page (`ProStudioPages.VERSIONS`, `/:projectId/:botId`
 * in `use-pro-studio-routes.tsx`, where `:botId` is the solution id), or `null`
 * when either part is missing.
 */
export const buildSolutionVersionsRoute = (
  projectId: string | null | undefined,
  solutionId: string | null | undefined
): string | null =>
  projectId && solutionId ? `/${projectId}/${solutionId}` : null;
